import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, ElementRef, ChangeDetectorRef, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { GroupService } from '../../services/group.service';

@Component({
  selector: 's18-payment-form',
  templateUrl: './payment-form.component.html',
  styleUrls: ['./payment-form.component.scss']
})
export class PaymentFormComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('cardInfo') cardInfo: ElementRef;
  card: any;
  cardHandler = this.onChange.bind(this);
  error: string;
  transactionData: any;
  promoCode: string = '';
  discount: number;
  displayPrice: number;
  showAmount: boolean = true;
  trial: boolean = false;

  lookingForDiscount: boolean = false;
  waitListMode: boolean = false;

  constructor(
    private groupService: GroupService,
    private dialog: MatDialog,
    private cd: ChangeDetectorRef,
    private dialogRef: MatDialogRef<PaymentFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log(data);
    this.dialogRef.disableClose = true;
    this.transactionData = data;
    this.displayPrice = this.transactionData.amount;
    if (this.transactionData.showAmount == false) {
      this.showAmount = false;
    }
    if (this.transactionData.trial) {
      this.trial = true;
    }
    if (this.transactionData.waitListMode) {
      this.waitListMode = true;
    }
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.card = elements.create('card');
    this.card.mount(this.cardInfo.nativeElement);

    this.card.addEventListener('change', this.cardHandler);
  }

  ngOnDestroy() {
    this.card.removeEventListener('change', this.cardHandler);
    this.card.destroy();
  }

  checkDiscount() {
    this.displayPrice = this.transactionData.amount;
    this.discount = null;
    if (this.promoCode.length > 4) {
      this.lookingForDiscount = true;
      this.groupService.checkPromoCode(this.promoCode)
        .subscribe(resp => {
          this.lookingForDiscount = false;
          var response = JSON.parse(resp.d).response;
          if (response.amount_off) {
            this.discount = response.amount_off / 100;
          } else {
            this.discount = this.transactionData.amount * response.percent_off / 100;
          }
          this.displayPrice = this.transactionData.amount - this.discount;
        });
    }
  }

  onChange({ error }) {
    if (error) {
      this.error = error.message;
    } else {
      this.error = null;
    }
    this.cd.detectChanges();
  }

  async onSubmit(form: NgForm) {
    const { token, error } = await stripe.createToken(this.card);

    if (error) {
      console.log('Something is wrong:', error);
      this.error = error.message;
    } else {
      console.log('Success!');
      token.couponCode = this.promoCode;
      token.price = this.displayPrice;
      token.s18_status = 'success';
      this.dialogRef.close(token);
    }
  }

  cancel() {
    this.dialogRef.close(null);
  }

}
